import { c as _c } from "react/compiler-runtime";
import { PersonIcon, QuestionMarkIcon, EmailIcon, WalletIcon } from '@systemeio/ui/icons';
import { NeutralButton, NeutralTypeEnum, toast } from '@systemeio/ui';
import { BookingPaymentStatusLink, BookingStatus } from 'modules/calendar/bookings/components/booking-status';
import { RescheduleBookingModal } from 'modules/calendar/bookings/components/reshedule-booking-modal';
import { BookingStatusEnum } from 'modules/calendar/bookings/constants';
import { useBookingAction } from 'modules/calendar/bookings/hooks/use-booking-action';
import { useBookingDetailsQuestions } from 'modules/calendar/bookings/hooks/use-booking-details-questions';
import { BookingDetailsInterface, BookingsInterface } from 'modules/calendar/bookings/types/booking-details-interface';
import { EventTypeEnum } from 'modules/calendar/events/enums/event-type-enum';
import React, { useState } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import { DisclosureBox } from 'shared/components/disclosure-box';
import { Loader } from 'shared/components/loader';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { KeyedMutator } from 'swr';
interface BookingQuestionsProps {
  booking: BookingsInterface;
  bookingDetails: BookingDetailsInterface;
  eventType: EventTypeEnum;
  bookingDetailsMutate: KeyedMutator<BookingDetailsInterface>;
  opened: boolean;
}
export const BookingQuestions = t0 => {
  const $ = _c(7);
  const {
    bookingDetails,
    booking,
    eventType,
    opened,
    bookingDetailsMutate
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== booking || $[1] !== bookingDetails || $[2] !== bookingDetailsMutate || $[3] !== eventType || $[4] !== opened || $[5] !== t) {
    t1 = <>{eventType === EventTypeEnum.Individual ? <IndividualTypeQuestions booking={booking} opened={opened} /> : <DisclosureBox buttonClassName="border-0" panelClassName="flex flex-col gap-4 pt-0 bg-brand-primary/10 rounded-b-lg" openButtonClassName="bg-brand-primary/10 rounded-t-lg" title={<div className="flex items-center gap-2"><PersonIcon className="fill-text-secondary h-4 w-4" /><span>{booking.inviteeName}</span></div>} subTitle={<span className="text-brand-primary">{t("dashboard.calendar.bookings.booking_details.invitees_details")}</span>} iconClassName="flex gap-2 items-center">{() => <GroupTypeQuestions booking={booking} bookingDetails={bookingDetails} bookingDetailsMutate={bookingDetailsMutate} />}</DisclosureBox>}</>;
    $[0] = booking;
    $[1] = bookingDetails;
    $[2] = bookingDetailsMutate;
    $[3] = eventType;
    $[4] = opened;
    $[5] = t;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};
type IndividualTypeQuestionsProps = {
  booking: BookingsInterface;
  opened: boolean;
};
const IndividualTypeQuestions = t0 => {
  const $ = _c(13);
  const {
    booking,
    opened
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== booking.bookingId || $[1] !== opened) {
    t1 = {
      bookingId: booking.bookingId,
      opened
    };
    $[0] = booking.bookingId;
    $[1] = opened;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    questions
  } = useBookingDetailsQuestions(t1);
  let t2;
  if ($[3] !== t) {
    t2 = t("dashboard.calendar.bookings.booking_details.questions_title");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <span className="text-text-primary mb-2 text-[18px] font-bold">{t2}</span>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== questions || $[8] !== t) {
    t4 = <div className="bg-brand-primary/10 flex flex-col gap-4 rounded-lg p-5">{questions ? <>{questions.length > 0 ? questions.map(_temp2) : <span>{t("dashboard.calendar.bookings.booking_details.no_questions_title")}</span>}</> : <div className="flex justify-center"><Loader /></div>}</div>;
    $[7] = questions;
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <div className="flex flex-col">{t3}{t4}</div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
type GroupTypeQuestionsProps = {
  bookingDetails: BookingDetailsInterface;
  booking: BookingsInterface;
  bookingDetailsMutate: KeyedMutator<BookingDetailsInterface>;
};
const GroupTypeQuestions = t0 => {
  const $ = _c(20);
  const {
    bookingDetails,
    bookingDetailsMutate,
    booking
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [openedRescheduleBookingModal, setOpenedRescheduleBookingModal] = useState(false);
  const [openedCancelBookingModal, setOpenedCancelBookingModal] = useState(false);
  const {
    cancelBooking,
    rescheduleBooking
  } = useBookingAction();
  let t1;
  if ($[0] !== booking.bookingId) {
    t1 = {
      bookingId: booking.bookingId,
      opened: true
    };
    $[0] = booking.bookingId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    questions
  } = useBookingDetailsQuestions(t1);
  let t2;
  if ($[2] !== booking.bookingId || $[3] !== bookingDetailsMutate || $[4] !== cancelBooking) {
    t2 = async () => {
      await cancelBooking(booking.bookingId, EventTypeEnum.Individual);
      await bookingDetailsMutate(data => {
        if (data) {
          return {
            ...data,
            bookings: data.bookings.map(item => {
              if (item.bookingId === booking.bookingId) {
                return {
                  ...item,
                  status: BookingStatusEnum.Cancelled
                };
              } else {
                return item;
              }
            })
          };
        }
      }, false);
      setOpenedCancelBookingModal(false);
    };
    $[2] = booking.bookingId;
    $[3] = bookingDetailsMutate;
    $[4] = cancelBooking;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onCancelBooking = t2;
  let t3;
  if ($[6] !== booking.bookingId || $[7] !== bookingDetailsMutate || $[8] !== rescheduleBooking || $[9] !== t) {
    t3 = async date => {
      await rescheduleBooking({
        id: booking.bookingId,
        date
      });
      await bookingDetailsMutate(data_0 => {
        if (data_0) {
          return {
            ...data_0,
            bookings: data_0.bookings.filter(item_0 => item_0.bookingId !== booking.bookingId)
          };
        }
      }, false);
      toast.success(t("dashboard.bookings.actions.reschedule_booking_success"));
      setOpenedRescheduleBookingModal(false);
    };
    $[6] = booking.bookingId;
    $[7] = bookingDetailsMutate;
    $[8] = rescheduleBooking;
    $[9] = t;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const onRescheduleBooking = t3;
  let t4;
  if ($[11] !== booking || $[12] !== bookingDetails || $[13] !== onCancelBooking || $[14] !== onRescheduleBooking || $[15] !== openedCancelBookingModal || $[16] !== openedRescheduleBookingModal || $[17] !== questions || $[18] !== t) {
    t4 = <>{questions ? <><div className="flex items-center gap-2"><EmailIcon className="fill-text-secondary h-4 w-4" /><span>{booking.inviteeEmail}</span></div>{booking.status === BookingStatusEnum.Cancelled && <div className="flex items-center gap-2"><span>{t("global.status")}</span><span><BookingStatus status={booking.status} /></span></div>}<div className="flex gap-2"><WalletIcon className="fill-text-secondary h-4 w-4" /><BookingPaymentStatusLink booking={booking} /></div><div className="flex items-center gap-2"><QuestionMarkIcon className="fill-text-secondary h-4 w-4" /><span>{t("dashboard.calendar.bookings.booking_details.questions_title")}</span></div><div className="pl-7">{questions.map(_temp4)}</div><div className="flex gap-4 pl-7">{bookingDetails.eventId !== null && ![BookingStatusEnum.Cancelled, BookingStatusEnum.Past].includes(booking.status) && <NeutralButton onClick={() => setOpenedCancelBookingModal(true)} neutralType={NeutralTypeEnum.danger}>{t("dashboard.calendar.bookings.booking_details.remove_invitee")}</NeutralButton>}{booking.status !== BookingStatusEnum.Cancelled && <NeutralButton onClick={() => setOpenedRescheduleBookingModal(true)}>{t("dashboard.calendar.bookings.booking_details.reschedule_invitee")}</NeutralButton>}</div><ConfirmationModal toastCaption={t("dashboard.bookings.actions.cancel_invitee_booking_success")} confirmationText={t("dashboard.calendar.bookings.actions.cancel_invitee_booking_confirm")} opened={openedCancelBookingModal} onClose={() => setOpenedCancelBookingModal(false)} onConfirm={() => onCancelBooking()} /><RescheduleBookingModal opened={openedRescheduleBookingModal} onClose={() => setOpenedRescheduleBookingModal(false)} booking={bookingDetails} onRescheduleBooking={onRescheduleBooking} bookingId={booking.bookingId} /></> : <div className="flex justify-center"><Loader /></div>}</>;
    $[11] = booking;
    $[12] = bookingDetails;
    $[13] = onCancelBooking;
    $[14] = onRescheduleBooking;
    $[15] = openedCancelBookingModal;
    $[16] = openedRescheduleBookingModal;
    $[17] = questions;
    $[18] = t;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
};
function _temp(userAnswer, index_0) {
  return <span key={`userAnswer-${userAnswer.title}-${index_0}`}>-{" "}{userAnswer.openAnswer !== null ? userAnswer.openAnswer : userAnswer.title}</span>;
}
function _temp2(question, index) {
  return <div className="flex flex-col gap-3" key={`question-${question.title}-${index}`}><span className="text-text-primary text-base">{question.title}</span><div className="flex flex-col gap-2">{question.userAnswers.map(_temp)}</div></div>;
}
function _temp3(userAnswer, index_0) {
  return <span key={`userAnswer-${userAnswer.title}-${index_0}`}>- {userAnswer.openAnswer !== null ? userAnswer.openAnswer : userAnswer.title}</span>;
}
function _temp4(question, index) {
  return <div className="mb-2 flex flex-col" key={`question-${question.title}-${index}`}><span className="text-text-primary text-base">{question.title}</span><div className="flex flex-col gap-2">{question.userAnswers.map(_temp3)}</div></div>;
}